import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", { class: "dial" }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dial.size, (symbol) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "symbol-container",
        style: _normalizeStyle(`transform: rotate(${ _ctx.getRotation(symbol) + _ctx.rotationOffset }deg);`)
      }, [
        _createElementVNode("div", { class: "symbol" }, [
          _createElementVNode("span", null, _toDisplayString(symbol), 1 /* TEXT */)
        ])
      ], 4 /* STYLE */))
    }), 256 /* UNKEYED_FRAGMENT */)),
    _createElementVNode("div", {
      class: "turn-left-clickzone",
      onClick: $event => (_ctx.turnDialLeft(_ctx.dial.id))
    }, null, 8 /* PROPS */, ["onClick"]),
    _createElementVNode("div", {
      class: "turn-right-clickzone",
      onClick: $event => (_ctx.turnDialRight(_ctx.dial.id))
    }, null, 8 /* PROPS */, ["onClick"])
  ]))
}